import { Validator } from '@vista-digital/validator';
export const defaultOccFilterDisplayText = {
    allOptionLabel: 'All',
    oneMonthSubscriptionBillingPeriodLabel: '1 month',
    subscriptionBillingPeriodLabel: '${billingPeriodInMonths} months',
    recurringSubscriptionBillingPeriodLabel: 'Recurring',
    nonRecurringSubscriptionBillingPeriodLabel: 'Non-recurring'
};
export const occFilterDisplayTextValidator = Validator.object({
    allOptionLabel: Validator.nonEmptyString,
    oneMonthSubscriptionBillingPeriodLabel: Validator.nonEmptyString,
    subscriptionBillingPeriodLabel: Validator.nonEmptyString,
    recurringSubscriptionBillingPeriodLabel: Validator.nonEmptyString,
    nonRecurringSubscriptionBillingPeriodLabel: Validator.nonEmptyString
});
//# sourceMappingURL=filter.js.map